import {makeStyles, MenuItem, TextField as MuiTextField} from "@material-ui/core";
import React, { FC } from "react";
import styled from "@emotion/styled";
import {IconButton} from "@mui/material";
import {Clear} from "@mui/icons-material";

const TextField = styled(MuiTextField)`
  width: 100%;
  background: #233145;
  & .MuiOutlinedInput-root {
    border-radius: 8px;
  },
  & .MuiInputBase-input {
    padding: 13.5px 13px;
    min-width: 33px;
    text-align: left;
  },
  & .MuiInputLabel-formControl {
    top: -5px
  },
  .MuiOutlinedInput-adornedEnd {
    padding: 0
  }
 `

const useStyles = makeStyles(theme => ({
  menuPaper: {
    maxHeight: 370
  }
}));

type PropsType = {
  selected: any,
  disabled?: boolean
  setSelected: (item: string) => void,
  list: any[]
  placeholder?: string
  clearButton?: boolean
  onClear?: () => void
  disabledItem?: number
}

const Select: FC<PropsType> = ({
  selected,
  setSelected,
  list,
  placeholder,
  disabled= false,
  clearButton = true,
  onClear,
  disabledItem
}) => {
  const classes = useStyles()

  const getMappedList = (list: any[]) => {
    if (typeof list[0] === 'number') {
      return list.map((item: any, index: number) => (
        <MenuItem key={index} value={item} disabled={!!(disabledItem && disabledItem === item)}>{item}</MenuItem>
      ))
    }
    return list.map((item: any, index: number) => (
      <MenuItem key={index} value={item.key}>
        {item.title}
      </MenuItem>
    ))
  }

  const handleClearButton = () => {
    if (clearButton && selected) {
      return (
        <IconButton
          style={{
            color: 'gray',
            position: 'absolute',
            right: '28px',
            padding: 0
          }}
          onClick={() => {
            setSelected('')
            if (onClear) {
              onClear()
            }
          }}
        >
          <Clear fontSize='small'/>
        </IconButton>
      )
    }

    return null
  }

  return (
    <TextField
      id="outlined-select-currency"
      select
      variant="outlined"
      value={selected}
      label={placeholder}
      onChange={(e: any) => (
        setSelected(e.target.value)
      )}
      disabled={list.length === 0 || disabled}
      InputProps={{
        endAdornment: handleClearButton(),
      }}
      SelectProps={{
        MenuProps: { classes: { paper: classes.menuPaper } }
      }}
    >
      {list.length > 0 ? (
        getMappedList(list)
      ) : <MenuItem/>}
    </TextField>
  )
}

export default Select
